import { Hex, toHex } from 'viem'

type Eip5792Capabilities = {
  // Legacy key — Uniswap and Relay still gate wallet_sendCalls on this
  // rather than the newer `atomic.status` field.
  atomicBatch: { supported: true }
  atomic: { status: 'supported' }
  // Dapps read this to skip their native gas-balance check, since Splits
  // sponsors gas by default.
  alternateGasFees: { supported: true }
}

export const buildEip5792CapabilitiesByChainId = (
  chainIds: number[],
): Record<Hex, Eip5792Capabilities> =>
  chainIds.reduce<Record<Hex, Eip5792Capabilities>>((acc, chainId) => {
    acc[toHex(chainId)] = {
      atomicBatch: { supported: true },
      atomic: { status: 'supported' },
      alternateGasFees: { supported: true },
    }
    return acc
  }, {})
